import React, { useState } from 'react';
import { FaChartArea, FaTable } from 'react-icons/fa';
import { BsPlus, BsGearFill, BsChatFill } from 'react-icons/bs';
import { RiLogoutCircleLine } from 'react-icons/ri';
import './sidebar.css';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import { setTab } from '../../../redux/actions/sideBarAction';
import { useNavigate } from 'react-router-dom';
import { LogoutAction } from '../../../redux/actions/authAction';
import ExitPageWarning from '../../Utils/Components/modals/exitPageWarning';

export default function SideBar() {
	const { selectedTab } = useTypedSelector((state) => state.sidebar);
	const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);
	const [newSelectedTab, setNewSelectedTab] = useState(selectedTab);

	const dispatch = useDispatch();

	const { unsavedChanges } = useTypedSelector((state) => state.global);

	const navigate = useNavigate();
	function handleClick(newSelectedTab: string) {
		if (!unsavedChanges) {
			navigate(newSelectedTab);
			// setNewSelectedTab(newSelectedTab);
			dispatch(setTab(newSelectedTab));
		} else {
			setIsWarnModalOpen(true);
			setNewSelectedTab(newSelectedTab);
		}
	}

	const Divider = () => <hr className="sidebar-hr" />;
	return (
		<div className="sidebar">
			<ExitPageWarning
				title={'Discard changes'}
				text={'Are you sure you want to discard your changes?'}
				setModalOpen={setIsWarnModalOpen}
				exitFunction={() => {
					navigate(newSelectedTab);
					dispatch(setTab(newSelectedTab));
				}}
				visible={isWarnModalOpen}
			/>
			<SideBarIcon
				icon={<FaChartArea size="24" />}
				text="Dashboard 📊"
				selectedTab="main-dashboard"
				isActive={selectedTab === 'main-dashboard'}
				handleClick={handleClick}
			/>

			<Divider />

			<SideBarIcon
				icon={<BsPlus size="32" />}
				text="Create new topic ➕"
				selectedTab="add-topic"
				isActive={selectedTab === 'add-topic'}
				handleClick={handleClick}
			/>

			<SideBarIcon
				icon={<FaTable size="20" />}
				text="Discover 🖼️"
				selectedTab="documents"
				isActive={selectedTab === 'documents'}
				handleClick={handleClick}
			/>

			<SideBarIcon
				icon={<BsChatFill size="20" />}
				text="Messages 📟"
				selectedTab="feedback"
				isActive={selectedTab === 'feedback'}
				handleClick={handleClick}
			/>

			<Divider />

			<SideBarIcon
				icon={<BsGearFill size="22" />}
				text="Settings 🔧"
				selectedTab="settings"
				isActive={selectedTab === 'settings'}
				handleClick={handleClick}
			/>

			<div className="mt-auto">
				<LogoutIcon />
			</div>
		</div>
	);
}

type SideBarProps = {
	icon: JSX.Element;
	text?: string;
	selectedTab: string;
	isActive: boolean;
	handleClick: (selectedTab: string) => void;
};

const SideBarIcon = ({
	icon,
	text = 'tooltip 💡',
	selectedTab,
	isActive = false,
	handleClick
}: SideBarProps) => {
	return (
		<div
			className={'group ' + (isActive ? 'sidebar-icon-active' : 'sidebar-icon')}
			onClick={() => {
				handleClick(selectedTab);
			}}
		>
			{icon}
			<span className="sidebar-tooltip group-hover:scale-100">{text}</span>
		</div>
	);
};

const LogoutIcon = () => {
	const dispatch = useDispatch();
	function handleClick() {
		dispatch(LogoutAction());
	}

	return (
		<div
			className={'group ' + 'sidebar-logout-icon'}
			onClick={() => {
				handleClick();
			}}
		>
			<RiLogoutCircleLine size="28" />
			<span className="sidebar-tooltip group-hover:scale-100">Logout 💔</span>
		</div>
	);
};
